export const HDFC_ACC = {
  aacount_name: {
    name: 'Account Name',
    value: 'VA Tech Ventures Pvt. Ltd.',
  },
  va_account_number: { name: 'Virtual Account Number' },
  ifsc_code: { name: 'IFSC Code' },
  bank_name: { name: 'Bank Name' },
  branch: { name: 'Branch', value: 'KANJUR MARG' },
  address: {
    name: 'Address',
    value:
      'I - THINK TECHNO CAMPUS, OPP CROMPTON GREAVES, NR KANJUR MARG RLY STATION, MUMBAI - 400042',
  },
};

export const RBL_ACC = {
  aacount_name: {
    name: 'Account Name',
    value: 'VA Tech Ventures Pvt. Ltd.',
  },
  va_account_number: { name: 'Virtual Account Number' },
  ifsc_code: { name: 'IFSC Code' },
  bank_name: { name: 'Bank Name' },
  branch: { name: 'Branch', value: 'BANGALORE-PRESTIGE TOWERS' },
  address: {
    name: 'Address',
    value: `THE RATNAKAR BANK LTD,G-13,G-14, G-15 & G-17 PRESTIGE TOWERS, 99 & 100 RESIDENCY ROAD, BANGALORE - 560025`,
  },
};
